import { createFileRoute } from "@tanstack/react-router";
import * as z from "zod";

import { SettingsAccountSubscription } from "@/features/my/settings/household/membership";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/household/membership",
)({
  validateSearch: z.object({
    membershipId: z.string().optional(),
  }),
  component: SettingsAccountSubscription,
});
